import React, { Fragment } from 'react';
import { ThemeProvider } from 'styled-components';
import Sticky from 'react-stickynode';
import { theme } from 'common/theme/saasMinimal2';
import { ResetCSS } from 'common/assets/css/style';
import {
  GlobalStyle,
  ContentWrapper,
} from 'containers/SaasMinimal2/saasMinimal2.style';
import { DrawerProvider } from 'common/contexts/DrawerContext';
import Seo from 'components/seo';
import Navbar from 'containers/SaasMinimal2/Navbar';
import Footer from 'containers/SaasMinimal2/Footer';
import ContactBanner from 'containers/SaasMinimal2/ContactBanner'
import ContactForm from 'containers/SaasMinimal2/ContactForm'

const contactPage = () => {

  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <Seo title="Zetit – Smart Hotel Booking Management & Calendar Sync Solution" />

        <ResetCSS />
        <GlobalStyle />
        <ContentWrapper>

          <Sticky top={0} innerZ={9999} activeClass="is-sticky">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          <ContactBanner/>
          <ContactForm/>
          <Footer />

        </ContentWrapper>
      </Fragment>
    </ThemeProvider>
  );
};
export default contactPage;
